import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class FactoryRushCapacityMode implements MutableValue {
  public isNew = true;

  private fCreatedAt?: Date;

  constructor(private fId: string) {
    [fId].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fId;
  }

  get createdAt(): Date | undefined {
    return this.fCreatedAt;
  }
}
